import { createI18n } from 'vue-i18n';
import { languages } from './index.js';

const getCookie = () => {
    const match = document.cookie.match(`(^|;)\\s*locale=([^;]*)`);
    return match ? match[2] : null;
};
const defaultLocale = getCookie('locale') || 'ru';

const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: 'ru',
    messages: {
        ...languages,
    },
});

export default i18n;
